import { Time } from '@instinet-analytics/core-lib';
import { toOptimizationUid } from 'widgets/estimatedTradeCost/widget/store/EstimatedTradeCostConfigState';

export type EstimatedTradeCostRequest = {
    orderId: string;
    orderQtyRemaining: number;
    specifiedQty?: number;
    inetSymbol: string;
    benchmark: string;
    profile: string;
    minPartLit: number;
    maxPartLit: number;
    strikeTime?: Time;
};

export const toUid = (r: EstimatedTradeCostRequest) =>
    `${r.orderId}/Opt:${toOptimizationUid(r)}/SpecifiedQty:${
        r.specifiedQty ?? ''
    }`;
